import { render, staticRenderFns } from "./CommodityFlowEdit.vue?vue&type=template&id=36bc2211&scoped=true&"
import script from "./CommodityFlowEdit.vue?vue&type=script&lang=js&"
export * from "./CommodityFlowEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc2211",
  null
  
)

export default component.exports